module.exports = __webpack_public_path__ + "img/xiaohui9.3af6b85c.jpg";